import { CountryCode, parsePhoneNumber } from 'libphonenumber-js';

import { ICandidate } from '../../../types';
import { IJob } from '../../JobSearchService';
import { ITeam } from '../../TeamSearchService';
import IJobCandidateInteractionDTO from '../types/IJobCandidateInteractionDTO';

import handleValidity from './handleValidity';
import isoCountries from './isoCountries';

const processPhoneNumbers = (
  candidates: ICandidate[],
  job: IJob,
  user: {
    email: string;
  },
  workAssignmentTeam?: ITeam
): IJobCandidateInteractionDTO[] => {
  const processedCandidates: IJobCandidateInteractionDTO[] = [];
  candidates.forEach((candidate) => {
    const processedCandidate = { ...candidate } as unknown as IJobCandidateInteractionDTO;
    processedCandidate.jobId = job ? job.id ?? '' : '';
    processedCandidate.mappedJobTitle = job ? job.title ?? '' : '';
    processedCandidate.candidateStatusTags = ['mapped'];
    processedCandidate.id = null;
    processedCandidate.candidateJobBoardId = '';
    processedCandidate.createdOn = '';
    processedCandidate.createdBy = user.email;
    processedCandidate.modifiedOn = '';
    processedCandidate.modifiedBy = user.email;
    processedCandidate.recruiterId = user.email;
    console.log(workAssignmentTeam);
    processedCandidate.team = workAssignmentTeam ?? null;
    processedCandidate.phoneNumber = '';
    processedCandidate.alternatePhoneNumbers = [];
    processedCandidate.isValid = false;
    processedCandidate.candidateId = candidate.id;
    processedCandidate.name = candidate.name;
    const phoneNumbers = [candidate.phoneNumber];
    if (candidate.alternatePhoneNumbers && candidate.alternatePhoneNumbers.length > 0) {
      candidate.alternatePhoneNumbers.map((number: string) => phoneNumbers.push(number));
    }
    phoneNumbers.forEach((phoneNumber) => {
      try {
        handleValidity(parsePhoneNumber(phoneNumber ?? ''), processedCandidate);
      } catch (error) {
        let country: CountryCode | null = null;
        if (candidate.currentLocation) {
          if (candidate.currentLocation.countryCode) {
            country = candidate.currentLocation.countryCode as CountryCode;
          } else if (candidate.currentLocation.country) {
            for (const code in Object.values(isoCountries)) {
              if (code === candidate.currentLocation.country) {
                country = code as CountryCode;
              }
            }
          }
        }

        if (country) {
          try {
            handleValidity(parsePhoneNumber(phoneNumber ?? '', country), processedCandidate);
          } catch (err) {
            console.log('Exception in handle validity', err);
          }
        }
      }
    });

    if (!processedCandidate.phoneNumber) {
      processedCandidate.phoneNumber = candidate.phoneNumber;
      processedCandidate.alternatePhoneNumbers = candidate.alternatePhoneNumbers;
    } else {
      processedCandidate.isValid = true;
    }

    processedCandidates.push(processedCandidate);
  });

  return processedCandidates;
};

export default processPhoneNumbers;
